import { SideNav } from 'foundations-components/transitional/components/SideNav';

/**
 * A [`SideNav`](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-sidenav--basic)
 * type component with router support.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const RouterSideNav = props => {
  return /*#__PURE__*/_jsx(SideNav, Object.assign({
    value: ""
  }, props));
};
export default RouterSideNav;